// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2q8cI","noInteraction":"EventWrapper_noInteraction__3BgrB"};